import { render, staticRenderFns } from "./BenefitSummaryNode.vue?vue&type=template&id=4b6597c1"
import script from "./BenefitSummaryNode.vue?vue&type=script&lang=js"
export * from "./BenefitSummaryNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports